/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type NotificationResourceAction = 'UNKNOWN' | 'NONE' | 'ACTIVATION_SUCCESS' | 'ACTIVATION_FAILED' | 'DEACTIVATION_INITIATED' | 'DEACTIVATION_SUCCESS' | 'DEACTIVATION_FAILED' | 'REQUEST_ACCESS_SUCCESS' | 'REQUEST_ACCESS_FAILED' | 'REQUEST_ACCESS_GRANTED' | 'REQUEST_ACCESS_DENIED' | 'UPGRADE_SCHEDULED' | 'UPGRADE_INITIATED' | 'UPGRADE_SUCCESS' | 'UPGRADE_FAILED' | 'UPGRADE_CANCELED' | 'UPGRADE_RESCHEDULED' | 'SUBSCRIPTION_ACTIVATION_SUCCESS' | 'SUBSCRIPTION_EXPIRING' | 'SUBSCRIPTION_EXPIRED' | 'MAINTENANCE_SCHEDULED' | 'MAINTENANCE_UPDATED' | 'MAINTENANCE_CANCELED' | 'MAINTENANCE_COMPLETED' | 'ORG_OVERAGE_ENFORMENT_CREATED' | 'AGENT_APP_SECRET_ROTATE_REQUEST' | 'VMC_HOST_BURST_ENABLED' | 'VMC_HOST_BURST_DISABLED' | 'VMC_HOST_BURST_DISABLE_FAILED' | 'LICENSE_STATE_DEGRADED' | 'LICENSE_STATE_SUSPENDED' | 'LICENSE_STATE_RESTORED' | 'OFFLINE_LICENSE_STATE_GRACE' | 'OFFLINE_LICENSE_STATE_DEGRADED' | 'OFFLINE_LICENSE_STATE_SUSPENDED' | 'OFFLINE_LICENSE_STATE_RESTORED' | 'OFFLINE_LICENSE_STATE_WARNING';

export const NotificationResourceAction = {

    UNKNOWN: 'UNKNOWN' as NotificationResourceAction,

    NONE: 'NONE' as NotificationResourceAction,

    ACTIVATION_SUCCESS: 'ACTIVATION_SUCCESS' as NotificationResourceAction,

    ACTIVATION_FAILED: 'ACTIVATION_FAILED' as NotificationResourceAction,

    DEACTIVATION_INITIATED: 'DEACTIVATION_INITIATED' as NotificationResourceAction,

    DEACTIVATION_SUCCESS: 'DEACTIVATION_SUCCESS' as NotificationResourceAction,

    DEACTIVATION_FAILED: 'DEACTIVATION_FAILED' as NotificationResourceAction,

    REQUEST_ACCESS_SUCCESS: 'REQUEST_ACCESS_SUCCESS' as NotificationResourceAction,

    REQUEST_ACCESS_FAILED: 'REQUEST_ACCESS_FAILED' as NotificationResourceAction,

    REQUEST_ACCESS_GRANTED: 'REQUEST_ACCESS_GRANTED' as NotificationResourceAction,

    REQUEST_ACCESS_DENIED: 'REQUEST_ACCESS_DENIED' as NotificationResourceAction,

    UPGRADE_SCHEDULED: 'UPGRADE_SCHEDULED' as NotificationResourceAction,

    UPGRADE_INITIATED: 'UPGRADE_INITIATED' as NotificationResourceAction,

    UPGRADE_SUCCESS: 'UPGRADE_SUCCESS' as NotificationResourceAction,

    UPGRADE_FAILED: 'UPGRADE_FAILED' as NotificationResourceAction,

    UPGRADE_CANCELED: 'UPGRADE_CANCELED' as NotificationResourceAction,

    UPGRADE_RESCHEDULED: 'UPGRADE_RESCHEDULED' as NotificationResourceAction,

    SUBSCRIPTION_ACTIVATION_SUCCESS: 'SUBSCRIPTION_ACTIVATION_SUCCESS' as NotificationResourceAction,

    SUBSCRIPTION_EXPIRING: 'SUBSCRIPTION_EXPIRING' as NotificationResourceAction,

    SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED' as NotificationResourceAction,

    MAINTENANCE_SCHEDULED: 'MAINTENANCE_SCHEDULED' as NotificationResourceAction,

    MAINTENANCE_UPDATED: 'MAINTENANCE_UPDATED' as NotificationResourceAction,

    MAINTENANCE_CANCELED: 'MAINTENANCE_CANCELED' as NotificationResourceAction,

    MAINTENANCE_COMPLETED: 'MAINTENANCE_COMPLETED' as NotificationResourceAction,

    ORG_OVERAGE_ENFORMENT_CREATED: 'ORG_OVERAGE_ENFORMENT_CREATED' as NotificationResourceAction,

    AGENT_APP_SECRET_ROTATE_REQUEST: 'AGENT_APP_SECRET_ROTATE_REQUEST' as NotificationResourceAction,

    VMC_HOST_BURST_ENABLED: 'VMC_HOST_BURST_ENABLED' as NotificationResourceAction,

    VMC_HOST_BURST_DISABLED: 'VMC_HOST_BURST_DISABLED' as NotificationResourceAction,

    VMC_HOST_BURST_DISABLE_FAILED: 'VMC_HOST_BURST_DISABLE_FAILED' as NotificationResourceAction,

    LICENSE_STATE_DEGRADED: 'LICENSE_STATE_DEGRADED' as NotificationResourceAction,

    LICENSE_STATE_SUSPENDED: 'LICENSE_STATE_SUSPENDED' as NotificationResourceAction,

    LICENSE_STATE_RESTORED: 'LICENSE_STATE_RESTORED' as NotificationResourceAction,

    OFFLINE_LICENSE_STATE_GRACE: 'OFFLINE_LICENSE_STATE_GRACE' as NotificationResourceAction,

    OFFLINE_LICENSE_STATE_DEGRADED: 'OFFLINE_LICENSE_STATE_DEGRADED' as NotificationResourceAction,

    OFFLINE_LICENSE_STATE_SUSPENDED: 'OFFLINE_LICENSE_STATE_SUSPENDED' as NotificationResourceAction,

    OFFLINE_LICENSE_STATE_RESTORED: 'OFFLINE_LICENSE_STATE_RESTORED' as NotificationResourceAction,

    OFFLINE_LICENSE_STATE_WARNING: 'OFFLINE_LICENSE_STATE_WARNING' as NotificationResourceAction
};

